// Reputation Module Tour
// Review requests, review management, listings and reputation widgets
// Selector policy: step 1 pins to the LIVE-VERIFIED sidebar id (#sb_reputation); the teaching steps are
// deliberate centered cards — no guessed element selectors (a wrong spotlight is worse than none).

export const reputationTour = {
  id: 'reputation',
  name: 'Reputation Module Tour',
  displayName: 'Build A 5-Star Reputation',
  description: 'Review requests, review management, listings and reputation widgets',
  estimatedDuration: '4 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: {
    animate: true,
    overlayOpacity: 0.75,
    smoothScroll: true,
    allowClose: true,
    showProgress: true
  },

  steps: [
    {
      element: '#sb_reputation',
      popover: {
        title: "⭐ Welcome to Reputation",
        description: `
          Reviews decide whether strangers trust you. This module asks for them, manages them, and shows them off — on autopilot.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📨 Review Requests",
        description: `
          Send a **review request** by email or text, one contact at a time or in bulk. The customer taps one link and lands exactly where you want them to review.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🔗 Your Review Link",
        description: `
          Set the **destination** once — your Google Business Profile or Facebook page — and every request from every teammate steers customers to the platform that matters most.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🤖 Automate the Ask",
        description: `
          The best time to ask is right after the win. Trigger review requests from a **workflow** — job completed, invoice paid, appointment finished — and they go out without anyone remembering to send them.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "💬 Manage Reviews",
        description: `
          Every review lands in one inbox. **Reply** to praise and complaints in the same place, and reply fast — response time is what future customers actually read.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "📍 Listings",
        description: `
          **Listings** pushes your business name, address, and hours to the directories that feed search. Consistent details across the web mean you show up where customers look.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🖼️ Review Widgets",
        description: `
          Embed a **review widget** on your website or funnel so your best reviews sell for you, right at the moment someone is deciding.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎥 Video Testimonials",
        description: `
          Text reviews build trust; **video testimonials** close deals. Collect them with a request link and use them in funnels and ads.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Your Reputation Runs Itself",
        description: `
          You can now:

✅ Request reviews by email or text
✅ Point every request at the right platform
✅ Automate the ask from a workflow
✅ Reply, list, and showcase

**Next:** set your review link, then automate one request from your most common workflow.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
